<template>
  <div v-if="heroItem">
    <!--<div
      style="
        z-index: 50000;
        position: fixed;
        bottom: 0;
        left: 0;
        color: #fff;
        background: blue;
        padding: 10px;
      "
    >
      {{ this.test.innerHeight }}<br />
      {{ this.test.scrollY }}<br />
      {{ this.test.offsetHeight }}<br />
    </div>-->
    <div class="key-visual">
      <div class="mask">
        <div class="contents">
          <div class="txt">
            We are digital experts<br />
            who will make<br />
            your business greater.
          </div>
          <router-link :to="`/works/${heroItem.id}`" class="key-button">See works</router-link>
        </div>
        <div
          class="bg"
          :style="{
            backgroundImage: `url(${imgUrl(heroItem.moDetailImagePhysicalName)})`
          }"
        ></div>
      </div>
    </div>
    <div class="work-wrap">
      <div class="contents">
        <p class="description">
          하나의 프로젝트를 완성하기 위해<br />
          디테일한 부분까지 집중하고 몰입하여<br />
          <span class="fc-red"> 완벽함을 만들어 냅니다.</span>
        </p>
      </div>
      <div class="category-tabs-wrap">
        <ul class="category-tabs" ref="categoryTabs">
          <li
            v-for="tab in categoryTabs"
            :key="tab.label"
            :class="{on: activeCategory === tab.code}"
            :ref="`tab-${tab.label}`"
          >
            <button type="button" @click="changeCategory(tab.code, tab.label)">
              {{ tab.label }}
            </button>
          </li>
        </ul>
      </div>
      <div class="contents">
        <ul class="work-list" v-if="listData.length > 0">
          <li
            v-for="(item, index) in listData"
            :key="item.id"
            :class="{txtTime: !item.moBigImagePhysicalName}"
          >
            <router-link :to="`/works/${item.id}`">
              <div class="thumb">
                <img :src="imgUrlIndex(item, index)" alt="" />
              </div>
              <div class="info">
                <i class="circle" />
                <div class="title">{{ item.projectServiceName }}</div>
                <div class="desc">{{ item.projectType }}</div>
                <span class="more">Read More</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import {Power0, TweenMax} from "gsap";
  import {commonMethods} from "@/utils/common-methods";
  import {mapGetters} from "vuex";
  import {apiWorksList} from "@/api";
  export default {
    name: "worksList",
    mixins: [commonMethods],
    data() {
      return {
        scene: null,
        page: 0,
        size: 10,
        totalPage: 0,
        keyword: "",
        listData: [],
        heroItem: null,
        loading: false,
        activeCategory: null,
        initialLabel: null,
        categoryTabs: [
          {label: "ALL", code: null},
          {label: "AI/AX", code: "PCG_AI_AX"},
          {label: "UI/UX", code: "PCG_UI_UX"},
          {label: "Consulting", code: "PCG_CONSULTING"},
          {label: "Motion film", code: "PCG_MOTION_FILM"}
        ],
        test: {
          innerHeight: 0,
          scrollY: 0,
          offsetHeight: 0
        }
      };
    },
    props: ["keyVisualMove"],
    computed: {
      ...mapGetters(["GE_CONT_HEIGHT"])
    },
    watch: {
      GE_CONT_HEIGHT() {
        if (this.$el.offsetParent) {
          this.init();
        }
      }
    },
    activated() {
      this.init();
    },
    methods: {
      infiniteScroll() {
        if (
          this.page < this.totalPage &&
          !this.loading &&
          window.innerHeight + window.scrollY >= document.body.offsetHeight - 10
        ) {
          this.page = this.page + 1;
          this.fetchData();
        }
      },
      changeCategory(code, label) {
        if (this.activeCategory === code || this.loading) return;
        this.activeCategory = code;
        this.page = 0;
        this.totalPage = 0;
        this.listData = [];
        this.fetchData();
        this.$nextTick(() => {
          this.scrollActiveTab(label);
        });
      },
      scrollActiveTab(label) {
        const tabsEl = this.$refs.categoryTabs;
        const tabEl = this.$refs[`tab-${label}`];
        const target = Array.isArray(tabEl) ? tabEl[0] : tabEl;
        if (!tabsEl || !target) return;
        const left = target.offsetLeft - (tabsEl.clientWidth - target.clientWidth) / 2;
        tabsEl.scrollTo({
          left: Math.max(left, 0),
          behavior: "smooth"
        });
      },
      imgUrlIndex(item, index) {
        const a = process.env.VUE_APP_API_URL;
        const b = index % 3 === 1 ? item.moSmallImagePhysicalName : item.moSmallImagePhysicalName; // moBigImagePhysicalName
        return a + b;
      },
      init() {
        this.scene?.destroy(true);
        const keyVisual = document.querySelector(".key-visual");
        if (!keyVisual) return;
        const tween = TweenMax.to(keyVisual.querySelector(".bg"), 1, {
          y: keyVisual.clientHeight,
          ease: Power0.easeInOut
        });
        const tween2 = TweenMax.to(keyVisual.querySelector(".txt"), 1, {
          y: keyVisual.clientHeight + keyVisual.querySelector(".txt").clientHeight,
          ease: Power0.easeInOut
        });
        const tween3 = TweenMax.to(keyVisual.querySelector(".key-button"), 1, {
          y: keyVisual.clientHeight + 200,
          ease: Power0.easeInOut
        });
        this.scene = this.$scrollmagic
          .scene({
            triggerElement: keyVisual,
            triggerHook: 0,
            duration: keyVisual.clientHeight * 2
          })
          .setTween([tween, tween2, tween3]);
        this.$scrollmagic.addScene(this.scene);
      },
      async fetchData() {
        try {
          this.loading = true;
          const params = {
            page: this.page,
            size: this.size,
            keyword: this.keyword,
            projectCategoryCodes: this.activeCategory ? [this.activeCategory] : []
          };
          const {
            data: {data: response}
          } = await apiWorksList(params);
          this.totalPage = response.totalPages;
          this.listData = this.listData.concat(response.content);
          if (!this.heroItem && response.content.length > 0) {
            this.heroItem = response.content[0];
          }
          this.$nextTick(() => {
            this.loading = false;
            this.init();
            if (this.initialLabel) {
              this.scrollActiveTab(this.initialLabel);
              this.initialLabel = null;
            }
          });
        } catch (error) {
          this.loading = false;
          console.error(error);
        }
      },
      setRandomCategory() {
        const candidates = this.categoryTabs.filter(
          tab => tab.code && tab.code !== "PCG_MOTION_FILM"
        );
        const picked = candidates[Math.floor(Math.random() * candidates.length)];
        this.activeCategory = picked.code;
        this.initialLabel = picked.label;
      }
    },
    created() {
      this.setRandomCategory();
      this.fetchData();
      window.addEventListener("scroll", this.infiniteScroll);
    },
    deactivated() {
      window.removeEventListener("scroll", this.infiniteScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.infiniteScroll);
      this.scene?.destroy(true);
    }
  };
</script>
<style lang="scss" scoped>
  .key-visual {
    position: relative;
    height: 100vh;
    min-width: $globalWidth;
    .mask {
      height: 100%;
      position: relative;
      overflow: hidden;
    }
    .contents {
      z-index: 2;
      position: relative;
      display: flex;
      justify-content: center;
      flex-direction: column;
      height: 100%;
    }
    .txt {
      @include montserrat;
      font-size: 36px;
      line-height: 45px;
      font-weight: bold;
      color: $red;
    }
    .key-button {
      flex: 0 0 auto;
      display: block;
      border: none;
      border-radius: 50%;
      background: $red;
      font-size: 13px;
      @include montserrat();
      color: #fff;
      height: 84px;
      width: 84px;
      text-align: center;
      line-height: 84px;
      margin-top: 60px;
    }
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      min-width: $globalWidth;
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
    }
  }
  .work-wrap {
    padding: 55px 0 40px;
    .description {
      font-size: 18px;
      line-height: 28px;
      color: #a0a0a0;
      font-weight: bold;
      span {
        color: $red;
      }
    }
    .category-tabs-wrap {
      margin-top: 80px;
      padding:40px 0;
    }
    .category-tabs {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      padding: 0 20px;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      li {
        flex: 0 0 auto;
        + li {
          margin-left: 25px;
        }
        &.on {
          button {
            color: $red;
            &:after {
              width: 100%;
              background: $red;
            }
          }
        }
        button {
          @include montserrat;
          padding: 0;
          border: 0;
          background: none;
          white-space: nowrap;
          font-weight: bold;
          font-size: 14px;
          line-height: 1;
          color: #a0a0a0;
          cursor: pointer;
          &:after {
            display: block;
            content: "";
            margin-top: 4px;
            width: 0;
            height: 2px;
            background: #a0a0a0;
            transition: width 250ms ease-in-out;
          }
        }
      }
    }
    .work-list {
      margin-top: 120px;
      li {
        margin-top: 80px;
        &:first-child {
          margin-top: 0;
        }
        // &:nth-child(2n + 1) {
        //   margin-right: 40px;
        // }
        // &:nth-child(2n) {
        //   margin-left: 40px;
        // }
      }

      a {
        display: block;
      }
      .thumb {
        display: block;
        border-radius: 10px;
        overflow: hidden;
        width: 100%;
        img {
          width: 100%;
          vertical-align: top;
        }
      }
      .circle {
        display: block;
        width: 10px;
        height: 10px;
        margin-top: 20px;
        border-radius: 100%;
        background: $red;
      }
      .title {
        margin-top: 15px;
        @include montserrat;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: bold;
      }
      .desc {
        margin-top: 8px;
        @include montserrat;
        font-size: 13px;
        line-height: 20px;
        color: #a0a0a0;
      }
      .more {
        margin-top: 25px;
        display: inline-flex;
        border-bottom: 1px solid #000;
        @include montserrat;
        font-size: 13px;
        color: #000;
        line-height: 19px;
      }
    }
  }
</style>
